import React from "react";
import { Helmet } from "react-helmet";

const CommonSeoContent = ({
  title,
  description,
  keywords,
  author,
  heading,
  whyUseText,
  howToUseSteps = [],
  features = [],
  inputExample,
  inputTitle,
  outputTitle,
  outputExample,
  callToAction,
}) => {
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
      </Helmet>

      {/* SEO Content */}
      <div className="seo-content mt-6 seo-section">
        <h2>{heading}</h2>
        <p>{whyUseText}</p>

        <h3>How to Use</h3>
        <ol>
          {howToUseSteps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ol>

        <h3>Features</h3>
        <ul>
          {features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>

        {inputExample && (
          <>
            <h3>Example</h3>
            <p><strong>{inputTitle || "Input Json:"}</strong></p>
            <pre>{inputExample}</pre>
          </>
        )}

		{outputExample && (
		  <>
			<p><strong>{outputTitle || "Output:"}</strong></p>
			<pre>{outputExample}</pre>
		  </>
		)}

        <p>{callToAction}</p>
      </div>
    </>
  );
};

export default CommonSeoContent;
